import {ReplyEntry, CreateQnaReplyApiProps} from "../../../../types/support/qna";
import {useEditQnaReply} from "../hooks/useEditQnaReply";
import ReplyEditRow from "../../../../components/common/ReplyEditRow";

interface ReplyEditRowProps {
    data: ReplyEntry;
    onCanceled: (key:string) => void;
    qnaId: string;
}

export default function QnaReplyCreateRow(props: ReplyEditRowProps) {
    const {data, onCanceled, qnaId} = props;

    const {
        removeFile,
        handleButtonClick,
        UploadUI,
        inputData,
        setInputData,
        createQnaReply
    } = useEditQnaReply({data: data, onCanceled, qnaId: qnaId});

    return <ReplyEditRow setter={setInputData}
                         data={inputData}
                         removeFile={removeFile}
                         handleButtonClick={handleButtonClick}
                         UploadUI={UploadUI}
                         updateReply={()=>createQnaReply(inputData as CreateQnaReplyApiProps)}
                         onCanceled={()=>onCanceled(inputData.qnaReplyId)}/>
}